import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "link"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

export const TextAreaFormInp = ({
  id,
  label,
  labelClass,
  name,
  required = false,
  placeholder,
  txtInpClass = "inp-textarea",
  containerClass = "input-group",
  disabled = false,
  ...props
}) => {
  const methods = useFormContext();
  useEffect(() => {
    methods.register(name, { required: required });
  }, [name]);

  const onEdit = (editorState) => {
    methods.setValue(name, editorState);
  };

  const value = methods.watch(name);

  const styles = {
    minHeight: "300px",
    width: "100%",
  };

  return (
    <div className={containerClass}>
      {label && (
        <label htmlFor={id} className={labelClass}>
          {label}
        </label>
      )}
      <ReactQuill
        theme="snow"
        modules={modules}
        formats={["header", "bold", "italic", "underline", "link", "list"]}
        value={value}
        onChange={onEdit}
        placeholder="Text..."
        readOnly={disabled}
        style={styles}
        {...props}
      />
    </div>
  );
};
